import React, { useRef, useEffect, useState } from "react";
import { Row, Col, Card, Typography, Select, Button, Pagination } from "antd";
import LeadCard from "./LeadCard";
import AdminCard from "./AdminCard";
import { FilterOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import "./newDashboard.css";
import useLeadOptions from "../../components/NewDashboard/UseLeadOptions";
import axiosNew from "../../store/api/axiosNew";
import useBusinessDashboardApi from "../../hooks/useBusinessDashboardApi";
import { formatAmountIndian } from "./FormatAmount";

const MyLeadsBusinessRetailWeb = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { Title } = Typography;
  const dispatch = useDispatch();
  const [selectedLead, setSelectedLead] = useState(null);

  const [filters, setFilters] = useState({
    location: null,
    landType: null,
    budget: null,
    plotSize: null,
  });
  const filterLeads = location.state?.filters;
  const [filteredLeadsNav, setFilteredLeadsNav] = useState([]);
  const rightColRef = useRef(null);
  const [rightColPos, setRightColPos] = useState({ left: 0, width: 0 });
  // const [localStatusMap, setLocalStatusMap] = useState({});
  const userName = localStorage.getItem("name");
  const {
    allLeads,
    myRetailLeads,
    retailPagination,
    fetchAllLeads,
    fetchMyRetailLeads,
    updateLeadStatus,
    addLeadToCart,
    removeLeadFromCart,
  } = useBusinessDashboardApi();

  // Update right column position
  useEffect(() => {
    const updatePosition = () => {
      if (rightColRef.current) {
        const rect = rightColRef.current.getBoundingClientRect();
        setRightColPos({ left: rect.left, width: rect.width });
      }
    };
    updatePosition();
    window.addEventListener("resize", updatePosition);
    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  const fetchFilteredLeadsFromPage = async (filters) => {
    try {
      // setLoadingFiltered(true);

      const accessToken = localStorage.getItem("accessToken");
      const baseURL = "https://apilead.blaccdot.com/api/admin/all-lead";

      const params = {};
      if (filters?.area) params.search = filters.area;
      if (filters?.landType?.length > 0)
        params.category = filters.landType.join(",");
      if (filters?.budget?.length === 2) {
        params.minBudget = filters.budget[0];
        params.maxBudget = filters.budget[1];
      }
      if (filters?.plotSize?.length > 0)
        params.plotSize = filters.plotSize.join(",");

      const res = await axiosNew.get(baseURL, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      const data = res.data?.data?.leads || [];
      setFilteredLeadsNav(data);
    } catch (err) {
      console.error("Error fetching filtered leads:", err);
      setFilteredLeadsNav([]);
    } finally {
      // setLoadingFiltered(false);
    }
  };

  useEffect(() => {
    if (filterLeads) {
      fetchFilteredLeadsFromPage(filterLeads);
    }
  }, [filterLeads]);

  const apiLeads = Array.isArray(myRetailLeads) ? myRetailLeads : [];

  const leads = apiLeads.map((lead) => ({
    id: lead._id,
    name: lead.name,
    place: lead.location,
    price: lead.budget,
    currentRate: lead.currentRate,
    landType: lead.subcategory?.label || "",
    rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
    status: lead.status || "",
    user_status: lead.user_status || "",
    // user_status: localStatusMap[lead._id] ?? lead.user_status ?? "",
    siteVisit: lead.siteVisitDays?.join(", ") || "",
    lookingFor: lead.property_details || "",
    contact: lead.phone,
    type: lead.leadType,
    category: lead.category,
    sqft: lead.spaceSqft || 0,
    state:lead.state ||"",
    district:lead.district ||"",
    area:lead.area ||"",
    pincode:lead.pincode ||"",
    subCategoryId: lead.subcategory?._id,
    subCategoryLabel: lead.subcategory?.label || "",
    subCategoryName: lead.subcategory?.name || "",
    purpose: lead.purpose || "",
  }));

  // Priority lead
  const priorityLead = leads.find((lead) => {
    const [purchased, total] = (lead.rating || "0/0").split("/").map(Number);
    return total - purchased === 1;
  });

  const adminLead = priorityLead
    ? priorityLead
    : leads[Math.floor(Math.random() * leads.length)] || {};

  const {
    // subCategoryOptions,
    locationOptions,
    landTypeOptions,
    budgetOptions,
    plotSizeOptions,
  } = useLeadOptions(leads);

  // Filtered leads
  const filteredLeads = leads.filter((lead) => {
    return (
      (!filters.location ||
        filters.location.length === 0 ||
        filters.location.includes(lead.place)) &&
      (!filters.landType ||
        filters.landType.length === 0 ||
        filters.landType.includes(lead.landType)) &&
      (!filters.budget ||
        filters.budget.length === 0 ||
        filters.budget.some((b) => Number(lead.price) <= Number(b))) &&
      (!filters.plotSize ||
        filters.plotSize.length === 0 ||
        filters.plotSize.some((s) => Number(lead.sqft) >= Number(s)))
    );
  });

  const statusOptions = [
    { label: "Qualified", value: "qualified" },
    { label: "RNR", value: "rnr" },
    { label: "Intake", value: "intake" },
    { label: "Disqualified", value: "disqualified" },
  ];

  //   const handleLeadCheck = (lead, isChecked) => {
  //     if (isChecked) {
  //       addLeadToCart(lead); // this internally updates cartLeads
  //     } else {
  //       removeLeadFromCart(lead.id); // this internally updates cartLeads
  //     }
  //   };

  const handleFilter = () => navigate("/user-dashboard-filter");
  // const handleClearSearchFilter = () => {
  //   setFilters({
  //     location: [],
  //     landType: [],
  //     budget: [],
  //     plotSize: [],
  //   });
  //   // navigate("/user-dashboard-web", { replace: true, state: {} });
  // };

  const handleAddToCart = () => {
    navigate("/my-cart");
  };

  const leadsByStatus = React.useMemo(() => {
    return {
      qualified: leads.filter((l) => l.user_status === "qualified"),
      rnr: leads.filter((l) => l.user_status === "rnr"),
      intake: leads.filter((l) => l.user_status === "intake"),
      disqualified: leads.filter((l) => l.user_status === "disqualified"),
    };
  }, [leads]);

  const leadsToRender =
    filteredLeadsNav.length > 0 ? filteredLeadsNav : filteredLeads;

  const finalLeads = React.useMemo(() => {
    return leadsToRender.filter((lead) => lead.purpose === "BUILD");
  }, [leadsToRender]);

  return (
    <div style={{ padding: "4px", fontSize: "13px" }}>
      {/* <Title level={4} style={{ textAlign: "right" }}>
        {userName}
      </Title> */}

      {/* Page Title & Filters */}
      <Row gutter={16} align="middle" style={{ marginBottom: "16px" }}>
        <Col
          span={6}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Title level={4}>My Retail Leads </Title>
        </Col>

        {/* <Col span={13}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #DBEAFF",
              borderRadius: 6,
              overflow: "hidden",
              background: "#fff",
              width: "100%",
            }}
          >
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Select Location"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              value={filters.location}
              onChange={(value) =>
                setFilters((prev) => ({ ...prev, location: value }))
              }
              options={locationOptions}
            />

            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Land Type"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              value={filters.landType}
              onChange={(value) => setFilters({ ...filters, landType: value })}
              options={landTypeOptions}
            />
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Budget Range"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              value={filters.budget}
              onChange={(value) => setFilters({ ...filters, budget: value })}
              options={budgetOptions}
            />
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Plot Size"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              value={filters.plotSize}
              onChange={(value) => setFilters({ ...filters, plotSize: value })}
              options={plotSizeOptions}
            />
            <Button
              type="primary"
              style={{
                background: "blue",
                border: "none",
                borderRadius: 0,
                padding: "0 24px",
              }}
            >
              Search
            </Button>
          </div>
        </Col> */}
        {/* <Col span={2} style={{ paddingRight: 0 }}>
          <Button
            type="default"
            onClick={handleClearSearchFilter}
            style={{ border: "1px solid red", color: "red" }}
          >
            Clear
          </Button>
        </Col> */}
        {/* <Col span={2}>
          <Button
            icon={<FilterOutlined />}
            type="default"
            onClick={handleFilter}
          >
            Filter
          </Button>
        </Col> */}
      </Row>

      {/* Leads & Admin Card */}
      <Row gutter={20}>
        <Col span={6}>
          {leadsToRender.map((lead) => {
            return (
              <LeadCard
                key={`lead-${lead.id}`} // safer key
                {...lead}
                // showCheckbox={true}
                // checked={cartLeads.some((l) => l.id === lead.id)}
                // onCheck={(id, checked) => handleLeadCheck(lead, checked)}
                onClick={() => setSelectedLead({ ...lead })}
                isSelected={selectedLead?.id === lead.id}
              />
            );
          })}

          <Pagination
            simple
            showSizeChanger={false}
            current={retailPagination.currentPage}
            total={retailPagination.total || 10}
            pageSize={retailPagination.perPage}
            onChange={(page) => fetchMyRetailLeads(page)}
          />
        </Col>

        <Col flex="2px">
          <div
            style={{ width: 2, backgroundColor: "#DBEAFF", height: "100%" }}
          />
        </Col>

        <Col span={17} ref={rightColRef}>
          {selectedLead ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <Typography.Title level={4} style={{ margin: 0 }}>
                  Lead Details
                </Typography.Title>
                <Select
                  placeholder="Update Lead Status"
                  value={selectedLead?.user_status?.toLowerCase()}
                  style={{ width: 220 }}
                  options={statusOptions}
                  onChange={(selectedValue) => {
                    if (!selectedLead) return;

                    // 1️⃣ Optimistic UI update for LISTS + COLUMNS
                    // setLocalStatusMap((prev) => ({
                    //   ...prev,
                    //   [selectedLead.id]: selectedValue,
                    // }));
                    updateLeadStatus(selectedLead.id, selectedValue);
                    // 2️⃣ Update right-side panel immediately
                    setSelectedLead((prev) => ({
                      ...prev,
                      user_status: selectedValue,
                    }));
                  }}
                />
              </div>

              <Card
                style={{
                  borderRadius: 6,
                  background: "#fafafa",
                  marginBottom: 12,
                }}
              >
                <Row gutter={0}>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Name</strong>
                    <p>{selectedLead.name}</p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Contact No.</strong>
                    <p>{selectedLead.contact}</p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Client Location</strong>
                    <p>{selectedLead.place}</p>
                  </Col>
                  <Col span={6} className="col-padding">
                    <strong>Sq.ft</strong>
                    <p>{selectedLead.sqft}</p>
                  </Col>
                </Row>
                <Row gutter={0} style={{ marginTop: 10 }}>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Budget</strong>
                    <p>₹ {formatAmountIndian(selectedLead.price)}</p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Preferred location</strong>
                    <p>
                      {selectedLead?.state || ""}-{selectedLead?.district || ""}
                      -{selectedLead?.area || ""}--
                      {selectedLead?.pincode || ""}
                    </p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Site Visit</strong>
                    <p>{selectedLead.siteVisit}</p>
                  </Col>

                  <Col span={6} className="col-padding">
                    <strong>Looking For</strong>
                    <p>{selectedLead.lookingFor}</p>
                  </Col>
                </Row>
                {/* <Button
                  style={{ background: "blue", color: "white", marginTop: 16 }}
                  //   onClick={() => handleLeadCheck(selectedLead, true)}
                >
                  Buy Now
                </Button> */}
              </Card>
            </>
          ) : (
            <AdminCard
              {...adminLead}
              onTopPickClick={(leadId) =>
                navigate(`/user-dashboard?selectedleadid=${leadId}`)
              }
              //   onBuyNow={(lead) => handleLeadCheck(lead, true)}
            />
          )}

          <div
            className="thin-scroll"
            style={{
              display: "flex",
              gap: "8px",
              overflowX: "auto",
            }}
          >
            {statusOptions.map(({ label, value }) => {
              const leads = leadsByStatus[value] || [];

              return (
                <div
                  key={value}
                  className="thin-scroll"
                  style={{
                    minWidth: 240,
                    maxHeight: 360,
                    padding: "0 8px 8px",
                    background: "#f9fafb",
                    border: "1px solid #e5e7eb",
                    borderRadius: 6,
                    overflowY: "auto",
                  }}
                >
                  {/* Sticky Header */}
                  <h5
                    style={{
                      margin: 0,
                      marginBottom: 2,
                      position: "sticky",
                      top: 0,
                      background: "#f9fafb",
                      zIndex: 2,
                      padding: "16px 8px 8px",
                      borderBottom: "1px solid #e5e7eb",
                      fontSize: 14,
                    }}
                  >
                    {label} ({leads.length})
                  </h5>

                  {leads.length === 0 ? (
                    <Typography.Text type="secondary">
                      No leads available
                    </Typography.Text>
                  ) : (
                    leads.map((lead) => (
                      <LeadCard
                        key={lead.id}
                        {...lead}
                        showCheckbox={false}
                        onClick={() => setSelectedLead(lead)}
                        isSelected={selectedLead?.id === lead.id}
                      />
                    ))
                  )}
                </div>
              );
            })}
          </div>
        </Col>
      </Row>

      {/* Fixed cart */}
      {/* {cartLeads.length > 0 && (
        <div
          style={{
            position: "fixed",
            bottom: 20,
            left: rightColPos.left,
            width: rightColPos.width,
            background: "#fff",
            border: "1px solid #64a1f7ff",
            borderRadius: 8,
            padding: "12px 16px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            zIndex: 1000,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ color: "#007bff", fontSize: 16, fontWeight: 600 }}>
              No. of {cartLeads.length === 1 ? "lead" : "leads"} Selected:{" "}
              {cartLeads.length}
            </span>
            <span style={{ color: "#555", fontSize: 13 }}>
              * Lead amount may change while someone purchases the same lead at
              a time
            </span>
          </div>

          <Button type="primary" onClick={handleAddToCart}>
            View Cart
          </Button>
        </div>
      )} */}
    </div>
  );
};

export default MyLeadsBusinessRetailWeb;
